import backend from '@common/backend';

const BASE = '/reports';

export interface IAnswersQuery {
	report_type_id?: number;
	report_subtype_id?: number;
	student_id?: number;
	service_id?: number;
	group_id?: number;
	schedule_id?: number;
	number?: number;
	program_group_id?: number;
	academic_semester_id?: number;
	location_id?: number;
	from?: string;
	to?: string;
	old_version?: number | boolean;
}

export const answerFromBE = (answer: any) => ({
	// @TODO: Remove when BE will be fixed
	...answer,
	value: answer.value.toString(),
});

export const getTypes = async (query: any) => backend.get(`${BASE}/types`, { params: query });

export const getSubTypes = async (id: number) => backend.get(`${BASE}/types/${id}/subtypes`);

export const getAnswers = async (query: IAnswersQuery) =>
	backend.get(`${BASE}/answers`, {
		params: query,
	});

export const getAnswersList = async (query: IAnswersQuery) =>
	backend.get(`${BASE}/answers/list`, {
		params: query,
	});

export const saveAnswers = async (data: any) => backend.post(`${BASE}/answers`, data);

export const createReport = async (data: any) => backend.post(`${BASE}`, data);

export const generateCertificate = async (data: any) =>
	backend.post(`${BASE}/generateCertificate`, data);

export const generatePreschool = async (data: any) =>
	backend.post(`${BASE}/generate-preschool`, data);

export const generateSemester = async (data: any) =>
	backend.post(`${BASE}/generate-semester`, data);

export const generateMentorPoland = async (data: any) =>
	backend.post(`${BASE}/generate-mentor-poland`, data);

export const publishReports = async (data: any) => backend.post(`${BASE}/bulk/publish`, data);

export const unpublishReports = async (data: any) => backend.post(`${BASE}/bulk/unpublish`, data);

export const getPublishedReports = async (query: IAnswersQuery) =>
	backend.get(`${BASE}/published`, {
		params: query,
	});

export const getDisciplineAnswers = async (query: IAnswersQuery) =>
	backend
		.get(`${BASE}/disciplineAnswers`, {
			params: query,
		})
		.then((result: any) => ({
			...result,
			answers: result.answers.map(answerFromBE),
		}));

export const saveDisciplineAnswers = async (data: any) =>
	backend.post(`${BASE}/disciplineAnswers`, data);

export const getDisciplineAnswersOptions = async (disciplineId: number) =>
	backend.get(`${BASE}/disciplineAnswers/options?dicipline_id=${disciplineId}`);

export const getMetaQuestions = async (query?: any) =>
	backend.get(`${BASE}/metadataQuestions`, {
		params: query,
	});

export const getMetaAnswers = async (query: IAnswersQuery) =>
	backend.get(`${BASE}/metadataAnswers`, {
		params: query,
	});

export const saveMetaAnswers = async (data: any) => backend.post(`${BASE}/metadataAnswers`, data);

export interface IGenerateCertificateSelfStudy {
	student_id: number;
	schedule_program_id: number;
}

export const generateCertificateSelfStudy = async (data: IGenerateCertificateSelfStudy) =>
	backend.post(`${BASE}/generateCertificateForSelfStudy`, data);

export const getStudentFinalCertificatesStatistics = async (query: any) =>
	backend.get(`${BASE}/studentFinalCertificatesStatistics`, {
		params: query,
	});

export const createStudentFinalCertificate = async (query: any) =>
	backend.get(`${BASE}/studentFinalCertificateForProduct`, {
		params: query,
	});

export const toggleIsReviewedAnswer = async (id: any, data: any) =>
	backend.put(`${BASE}/answers/${id}/toggleIsReviewed`, data);

export type ReportCompareQuery = {
	report_subtype_id: number;
	student_id: number;
	schedule_id: number;
};

export type ReportCompare = {
	id: number;
	from: string;
	to: string;
	is_published?: number | boolean | string;
};

export const getReportCompares = (
	query: ReportCompareQuery,
	page: number,
	limit: number,
	signal: AbortSignal,
): Promise<ReportCompare[]> =>
	backend.get('/reportCompares', { params: { ...query, page, limit }, signal });

export const publishReportCompare = (id: number) =>
	backend.put(`/reportCompares/${id}`, { is_published: 1 });
